import React from "react";
import { connect } from "react-redux";
import { Row, Dropdown, Tooltip, Spin, message, Tabs } from 'antd';
import CONFIG from "../../config";
import {
    selectTitle,
    toggleBackButton,
    fetchAllDemoQuestions,
    toggleIsFetchingDemoQuestions,
    clearDemoQuestions,
    exportTable,
    clearDemoQuestionsTableData,
    handleOnClickAction,
    currentDemoQuestionsFilter,
    toggleSaveReportVisible,
    fetchLiteDemoQuestionsOrFeedbackQuestions
} from "../../actions";
import pushMessage from "../common/PushMessage";
import openConfirm from '../common/Confirm';
import { exportMenu } from "../../utils/strings";
import { fetchNamesBySearchString } from '../../actions/userRole'
import { deleteDemoQuestion, restoreDemoQuestion } from "../../actions/demoQuestions"
import { isTabAlreadyOpen } from "../common/TabLayout";
import SaveReport from "../common/SaveReport";
import throttle from 'lodash/throttle';
import { LoadingOutlined } from "@ant-design/icons";
import { Table as NeoTable, Icon as NeoIcon, Button as NeoButton } from "neo-latest";
import { checkIfFilterSortIsEmpty } from "../../utils/formChanged.js";
import FilterDrawer from "../common/FilterDrawer";
import { otherFields } from "../../utils/neoTableFields";
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const { TabPane } = Tabs;

const dataIndexMap = {
    title: 'title',
    createdBy: 'createdBy.fullName',
    createdTime: 'createdTime',
    updatedBy: 'updatedBy.fullName',
    updatedTime: 'updatedTime',
    status: 'isActive',
    viewDeletedItems: 'viewDeletedItems',
    answerType: 'answerType',
};

class ManageDemoQuestions extends React.Component {

    constructor(props) {
        super(props)

        this.handleClear = throttle(this.handleClear, 1000);

        this.state = {
            status: "true",
            matchedUsersNames: [],
            searchString: [],
            hasEnteredString: false,
            isFetching: false,
            isReturnedFromEdit: false,
            isReturnedFromDelete: false,
            deletedRecordIndex: undefined,
            showFilter: false,
            saveReport: false,
            questionType: "demo",
            currentPage: 0,
            currentPath: null
        }
    }

    filterSort = {};
    filterSave = {}
    demoQuestionId = undefined;
    recordIndex = undefined;
    flag = 0;
    isViewDeletedItemsChecked = undefined;

    tableRef = React.createRef();
    isDemoItemsChecked = false;


    fetchUsersName = searchString => {
        this.setState({ matchedUsersNames: [] });
        fetchNamesBySearchString({ searchString })
            .then((result) => {
                if (result?.length !== 0) {
                    delete result.id
                    this.setState({ matchedUsersNames: [...new Set(result.map(item => item.fullName))] })
                }
                this.setState({ hasEnteredString: false })
            });
    };

    clearCurrentDemoQuestions = async () => {
        await this.props.clearDemoQuestionsTableData();
        this.setState({ currentPage: 0 });
    }

    handleSelectChange = async (value) => {
        await this.clearCurrentDemoQuestions()
        this.setState({ status: value }, () => { this.handleFetchDemoQuestions() })
    }

    handleFilter = async (filters, isSave) => {
        let { title, viewDeletedItems, updatedBy, createdBy, answerType } = filters;
        if (Array.isArray(answerType)) answerType = answerType[0];
        const isFilter = isSave ? "save" : "filter";
        title = title?.trim();
        updatedBy = updatedBy?.trim();
        createdBy = createdBy?.trim();
        if (!title && !updatedBy && !createdBy && !answerType && !viewDeletedItems) {
            pushMessage(CONFIG.messageType.warning, `Please select some fields to ${isFilter}`);
            return;
        }
        if (viewDeletedItems || this.isViewDeletedItemsChecked) {
            this.setState({ status: "false" });
        }
        if (isSave) {
            this.filterSave = {
                ...this.filterSave,
                filter: {
                    ...(title && {
                        [dataIndexMap.title]: {
                            operator: "=",
                            oprVal: title || undefined

                        }
                    }),
                    ...(answerType && {
                        [dataIndexMap.answerType]: {
                            operator: "=",
                            oprVal: answerType || undefined
                        }
                    }),
                    ...(updatedBy && {
                        [dataIndexMap.updatedBy]: {
                            operator: "=",
                            oprVal: updatedBy || undefined
                        }
                    }),
                    ...(createdBy && {
                        [dataIndexMap.createdBy]: {
                            operator: "=",
                            oprVal: createdBy || undefined
                        }
                    }),
                    ...(viewDeletedItems && {
                        isSoftDelete: {
                            operator: "=",
                            oprVal: viewDeletedItems
                        }
                    })
                },
                filterTable: {
                    id: 13,
                    tableName: "Question"
                },
            }
            this.props.toggleSaveReportVisible(true)
            this.setState({ saveReport: true })
        }
        else {
            this.titleSearchString = title;
            await this.clearCurrentDemoQuestions();
            this.filterSort = {
                ...this.filterSort,
                filter: {
                    [dataIndexMap.title]: title || undefined,
                    [dataIndexMap.answerType]: answerType || undefined,
                    [dataIndexMap.createdBy]: createdBy || undefined,
                    [dataIndexMap.updatedBy]: updatedBy || undefined,
                    [dataIndexMap.viewDeletedItems]: viewDeletedItems,
                }
            }
            this.handleFetchDemoQuestions();
        }
    }

    handleClear = async (refresh) => {
        if (refresh) {
            await this.props.clearDemoQuestionsTableData();
            this.setState({ currentPage: 0 });
        }
        else {
            await this.clearCurrentDemoQuestions();
            this.titleSearchString = undefined;
            this.filterStatusTypes = undefined;
            this.filterSort = {};

        }
        this.props.toggleIsFetchingDemoQuestions(true);
        await this.handleFetchDemoQuestions();
        this.isViewDeletedItemsChecked = undefined;
        this.setState({ matchedUsersNames: [] });
        this.props.toggleIsFetchingDemoQuestions(false);

    };



    handleExport = async (fileType) => {
        const { timeZone } = this.props;
        pushMessage(CONFIG.messageType.isFetching, "Exporting", 0);
        const demoQuestions = await this.props.fetchLiteDemoQuestionsOrFeedbackQuestions({ getAll: true, filterSort: this.filterSort, status: this.state.status, questionType: this.state.questionType });
        if (demoQuestions?.length > 0 && demoQuestions !== undefined) {
            exportTable(CONFIG.exportTable.demoQuestion.name, demoQuestions, timeZone, CONFIG.exportTable.demoQuestion.fileName + `.${fileType}`, fileType)
                .then((response) => {
                    message.destroy()
                    const isExport = response.status === CONFIG.HTTP_STATUS.OK
                    pushMessage(isExport ? CONFIG.messageType.success : CONFIG.messageType.warning, isExport ? "Table exported successfully" : "There is no data to export. Please verify the filters")
                })
                .catch(() => {
                    message.destroy()
                    pushMessage(CONFIG.messageType.error, "Unable to export table")
                })
        }
        else {
            message.destroy()
            pushMessage(CONFIG.messageType.warning, "There is no data to export. Please verify the filters")
        }
    }


    handleSave = (filters) => {
        this.handleFilter(filters, true)
    }

    handleFetchDemoQuestions = async () => {
        this.props.toggleIsFetchingDemoQuestions(true);
        await this.props.fetchLiteDemoQuestionsOrFeedbackQuestions({ filterSort: this.filterSort, status: this.state.status, questionType: this.state.questionType });
        this.props.toggleIsFetchingDemoQuestions(false);
    }

    renderDeleteRestoreConfirmation = (isRestore) => {
        const okButtonText = isRestore && "Confirm Restore"
        const hardDelete = this.filterSort?.filter?.viewDeletedItems;
        const modalTitle = isRestore ? CONFIG.restoreModalTitle?.replace('<placeholder>', 'demo question') : CONFIG.deleteModalTitle?.replace('<placeholder>', 'demo question')
        const content = <>{hardDelete && !isRestore ? <h4>{CONFIG.warningMessages.hardDelete.replace("<placeHolder>", "Demo question")}</h4> : !isRestore ? <h4>{CONFIG.warningMessages.softDelete.replace("<placeHolder>", "Demo question")}</h4> : ""}</>
        openConfirm(okButtonText, isRestore ? this.handleRestoreConfirmation : this.handleDeleteConfirmation, null, content, modalTitle);
    }


    handleDeleteConfirmation = async () => {
        const hardDelete = this.filterSort?.filter?.viewDeletedItems;
        const response = await deleteDemoQuestion(this.demoQuestionId, hardDelete);
        if (response) {
            this.handleFetchDemoQuestionsAfterDeleteOrRestore()
        }
    }

    handleFetchDemoQuestionsAfterDeleteOrRestore = async () => {
        this.clearCurrentDemoQuestions();
        this.setState({ currentPage: this.props.currentPageNumber });
        this.fetchDemoQuestionsOnMount();
    }

    handleDeleteRestore = (questionId, isRestore) => {
        this.demoQuestionId = questionId;
        this.renderDeleteRestoreConfirmation(isRestore);
    }

    handleRestoreConfirmation = async () => {
        const response = await restoreDemoQuestion(this.demoQuestionId)
        if (response) {
            this.handleFetchDemoQuestionsAfterDeleteOrRestore();
        }
    }


    componentWillUnmount() {
        if (isTabAlreadyOpen({ openedTabs: this.props.openedTabs, currentComponentPath: this.state.currentPath })) {
            this.props.currentDemoQuestionsFilter(this.filterSort, this.state.status, this.state.currentPage);
            this.props.clearDemoQuestionsTableData();
        }
        else {
            this.props.clearDemoQuestions()
        }
    }

    fetchDemoQuestionsOnMount = async () => {
        this.props.toggleIsFetchingDemoQuestions(true)
        await this.props.fetchLiteDemoQuestionsOrFeedbackQuestions({ filterSort: this.filterSort, status: this.state.status, questionType: this.state.questionType });
        this.props.toggleIsFetchingDemoQuestions(false);

    }


    async componentDidMount() {
        const { isEdit, currentPageNumber, currentFilter, status } = this.props;
        this.props.toggleIsFetchingDemoQuestions(true);
        this.setState({ currentPath: window.location.pathname });
        if (isEdit) {
            this.setState({ currentPage: currentPageNumber });
            this.filterSort = currentFilter;
            if (Object.keys(JSON.parse(JSON.stringify(currentFilter)))?.length > 0) {
                const filterObject = JSON.parse(JSON.stringify(currentFilter?.filter));
                Object.keys(filterObject)?.length > 0 && this.setState({ showFilter: true })
            }
            await this.setState({ status: status });
        }
        else this.filterSort = {};
        this.fetchDemoQuestionsOnMount();
    }

    renderFilterPanel = () => {
        return (
            <div
                style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
            >
                {
                    <div style={{ display: "flex", flex: "1", zIndex: "1", position: "relative" }}>
                        <NeoButton
                            onClick={() => {
                                this.props.handleOnClickAction({
                                    component: CONFIG.createComponentRoute.demoQuestions,
                                    tabTitle: "Create",
                                });
                            }}
                        >
                            Add New
                        </NeoButton>
                    </div>
                }
                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        flex: "1",
                        flexDirection: "row-reverse",
                        gap: "24px",
                    }}
                >
                    <div>
                        <Dropdown overlay={exportMenu(this.handleExport)} trigger="click">
                            <NeoButton
                                className="export-download-button"
                                icon="chevron-down"
                                variant="secondary"
                            >
                                Download
                            </NeoButton>
                        </Dropdown>
                    </div>
                    <div>
                        <NeoIcon aria-label="menu-aria"
                            size="md"
                            className="clickable"
                            onClick={() =>
                                this.setState((prevState) => ({
                                    showFilter: !prevState.showFilter,
                                }))
                            }
                            title="Filter"
                            icon={
                                this.state.showFilter ||
                                    !checkIfFilterSortIsEmpty({ filter: this.filterSort })
                                    ? "filter-filled"
                                    : "filter"
                            }
                            style={{ fontSize: "23px", color: "#0b67bd" }}
                        />
                    </div>
                    <div>
                        <NeoIcon aria-label="menu-aria"
                            size="md"
                            className="clickable"
                            title="Refresh"
                            icon="refresh"
                            onClick={() => this.handleClear(true)}
                            style={{ fontSize: "23px", color: "#0b67bd" }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderTabContents = () => {
        return (
            <React.Fragment>
                <div>{this.renderFilterPanel()}</div>
                <div className="height-neo-table">{this.renderTable()}</div>
            </React.Fragment>
        );
    };

    renderTable = () => {
        const { userRoleTemplate, demoQuestions, isFetching } = this.props;
        const deleteView = this.filterSort?.filter?.viewDeletedItems;
        this.isViewDeletedItemsChecked = deleteView;
        const neoColumns = [
            {
                Cell: (a) => {
                    return (
                        <span style={{ textAlign: "center" }}>
                            {a?.cell?.row?.original?.title}
                        </span>
                    );
                },
                Header: "Title",
                sortType: "string",
                disableFilters: true,
                accessor: "title",
            },

            {
                Cell: (a) => {
                    return (
                        <span style={{ textAlign: "center" }}>
                            {a?.cell?.row?.original?.createdBy?.fullName}
                        </span>
                    );
                },
                Header: "Created By",
                sortType: "string",
                disableFilters: true,
                accessor: "createdBy.fullName",
            },

            {
                Cell: (a) => {
                    return (
                        <span style={{ textAlign: "center" }}>
                            {a?.cell?.row?.original?.answerType}
                        </span>
                    );
                },
                Header: "Answer Type",
                sortType: "string",
                disableFilters: true,
                accessor: "answerType",
            },

            {
                Cell: (a) => {
                    return (
                        <span style={{ textAlign: "center" }}>
                            {
                                <NeoIcon aria-label="menu-aria"
                                    style={
                                        a?.cell?.row?.original?.isActive
                                            ? { color: "#088A08" }
                                            : { color: "#DA291C" }
                                    }
                                    icon={
                                        a?.cell?.row?.original?.isActive ? "available" : "missed"
                                    }
                                />
                            }
                        </span>
                    );
                },
                sortType: "basic",
                Header: "Status",
                accessor: "isActive",
                disableFilters: true,
                disableSortBy: true,
            },

            {
                Cell: (a) => {
                    const record = a.cell.row.original;
                    const isEditDisabled = userRoleTemplate.templateType !== CONFIG.roleTypes.superAdmin;
                    return isEditDisabled ? null : (
                        <React.Fragment>
                            <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
                                {!deleteView &&
                                    <>
                                        <Tooltip title={isEditDisabled ? CONFIG.warningMessages.noAccess : undefined} key={record.id}>
                                            <button
                                                onClick={() => {
                                                    this.props.handleOnClickAction({
                                                        component: CONFIG.editComponentRoute.demoQuestions,
                                                        tabTitle: record?.title,
                                                        recordId: record?.id
                                                    })
                                                }}
                                                disabled={isEditDisabled}
                                                className={!isEditDisabled ? "link" : "link-disabled"}>
                                                <span class="neo-icon-edit" title="Edit" style={{ fontSize: "20px" }}></span>
                                            </button>
                                        </Tooltip>

                                    </>
                                }
                                {!deleteView && <>
                                    <Tooltip title={isEditDisabled ? CONFIG.warningMessages.noAccess : undefined} key={record.id}>
                                        <button disabled={isEditDisabled} className={!isEditDisabled ? "link" : "link-disabled"} onClick={() => this.handleDeleteRestore(record.id)}>
                                            <span class="neo-icon-trash" title="Delete" style={{ fontSize: "20px" }}></span>
                                        </button>
                                    </Tooltip>
                                </>
                                }
                                {deleteView &&
                                    <>

                                        <button disabled={isEditDisabled} className={!isEditDisabled ? "link" : "link-disabled"} onClick={() => this.handleDeleteRestore(record.id, true)}>
                                            <span class="neo-icon-history" title="Restore" style={{ fontSize: "20px" }}></span>
                                        </button>
                                    </>
                                }
                            </div>
                        </React.Fragment>
                    );
                },
                Header: "  ",
                disableFilters: true,
                disableSortBy: true,
            },
        ];

        return isFetching ? (
            <Spin
                style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                spinning={isFetching}
                indicator={antIcon}
            />
        ) : (
            <NeoTable
                columns={neoColumns}
                data={demoQuestions || []}
                className="table-actions"
                allowColumnFilter={false}
                itemsPerPageOptions={[10, 20, 50, 100]}
                showRowSeparator
                initialStatePageIndex={this.state.currentPage}
                handlePageChange={(newPageIndex) => {
                    if (newPageIndex >= 0) this.setState({ currentPage: newPageIndex })
                }}
                {...otherFields}
            />
        );
    };

    handleCloseFilterDrawer = () => {
        this.setState((prevState) => ({
            showFilter: !prevState.showFilter,
        }));
    };

    render() {
        const { userRoleTemplate, timeZone } = this.props;
        const formFields = [
            {
                label: "Title",
                type: CONFIG.formFieldTypes.INPUT,
                key: "title",
                value: this.filterSort?.filter?.title,
                colSpan: 24,
            },
            {
                label: "Answer Type",
                type: CONFIG.formFieldTypes.SELECT,
                key: "answerType",
                data: CONFIG.filterDataSet.demoQuestionAnswerTypes,
                colSpan: 24,
                mode: "default",
                value: this.filterSort?.filter?.[dataIndexMap.answerType]
            },
            {
                label: "Created By",
                type: CONFIG.formFieldTypes.SEARCH_SELECT,
                key: "createdBy",
                data: this.state.matchedUsersNames,
                value: this.filterSort?.filter?.[dataIndexMap.createdBy],
                colSpan: 24
            },
            {
                label: "Updated By",
                type: CONFIG.formFieldTypes.SEARCH_SELECT,
                key: "updatedBy",
                data: this.state.matchedUsersNames,
                value: this.filterSort?.filter?.[dataIndexMap.updatedBy],
                colSpan: 24
            }
        ];

        const shouldFetchDemos = userRoleTemplate && (userRoleTemplate.templateType === CONFIG.roleTypes.superAdmin || userRoleTemplate.templateType === CONFIG.roleTypes.admin);
        return (
            <React.Fragment>
                <div
                    style={{
                        color: "#242424",
                        fontSize: "19px",
                        fontWeight: "400",
                        lineHeight: "28px",
                        marginTop: "28px",
                    }}
                >
                    List of Demo Questions
                </div>
                <div style={{ marginTop: "16px" }}>
                    <Tabs
                        disabled={this.isViewDeletedItemsChecked}
                        activeKey={this.state.status}
                        className="demo-status-tabs"
                        defaultActiveKey={this.state.status}
                        onChange={this.handleSelectChange}
                    >
                        <TabPane
                            disabled={this.isViewDeletedItemsChecked}
                            tab="Active"
                            key="true"
                        >
                            {this.renderTabContents()}
                        </TabPane>
                        <TabPane
                            tab="Inactive"
                            key="false"
                        >
                            {this.renderTabContents()}
                        </TabPane>
                        <TabPane
                            disabled={this.isViewDeletedItemsChecked}
                            tab="All"
                            key="all"
                        >
                            {this.renderTabContents()}
                        </TabPane>
                    </Tabs>
                </div>
                <div id="component-content" className="approvals-pagination-row">
                    <div></div>
                    <Row>
                        {this.state.showFilter && (
                            <FilterDrawer
                                visible={this.state.showFilter}
                                width="520"
                                handleCloseFilterDrawer={this.handleCloseFilterDrawer}
                                placement="right"
                                maskClosable={true}
                                panelHeader="Filters and Export"
                                formFields={formFields}
                                handleClear={this.handleClear}
                                handleFilter={this.handleFilter}
                                handleSave={shouldFetchDemos ? this.handleSave : undefined}
                                timeZone={timeZone}
                                hideSoftDeleteCheckbox={false}
                                hideSave={false}
                                getSearchData={this.fetchUsersName}
                                label='View Deleted Demo Questions'
                                viewDeletedItemsValue={this.filterSort?.filter?.viewDeletedItems}
                                hideApplyToAll={true}
                            />
                        )}
                    </Row>
                </div>
                {this.state.saveReport && <SaveReport closeModal={() => this.setState({ saveReport: false })} reportFilter={this.filterSave} />}
            </React.Fragment>
        );
    }
}

const mapStateToProps = ({ user, demoQuestions, tabsLayout }) => {
    return {
        userRoleTemplate: user.profile ? user.profile.roleTemplate : undefined,
        demoQuestions: demoQuestions?.questions,
        isFetching: demoQuestions?.isFetching,
        timeZone: user.profile.timezone,
        currentFilter: demoQuestions.currentFilter,
        status: demoQuestions.status,
        isEdit: demoQuestions.isEdit,
        demoQuestionsCount: demoQuestions?.questionCount,
        currentPage: demoQuestions.currentPage,
        currentPageNumber: demoQuestions.currentPageNumber,
        response: demoQuestions.response,
        demoIndex: demoQuestions.demoIndex,
        pageSize: demoQuestions.pageSize,
        openedTabs: tabsLayout.panes
    };
};

export default connect(mapStateToProps, {
    selectTitle,
    toggleBackButton,
    fetchAllDemoQuestions,
    toggleIsFetchingDemoQuestions,
    clearDemoQuestions,
    exportTable,
    handleOnClickAction,
    currentDemoQuestionsFilter,
    clearDemoQuestionsTableData,
    toggleSaveReportVisible,
    fetchLiteDemoQuestionsOrFeedbackQuestions

})(ManageDemoQuestions);